var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-template',{attrs:{"loading":_vm.loading,"total":_vm.total,"table-data":_vm.tableData.list,"search-config":_vm.searchConfig,"table-config":_vm.tableConfig,"current-page":_vm.page},on:{"onSearch":_vm.onSearch,"onReset":_vm.onReset,"onChangePage":_vm.changeCurrentPage,"onHandle":_vm.tableHandle}})
}
var staticRenderFns = []

export { render, staticRenderFns }